var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentActivityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.197,
    height: 17.194,
    viewBox: "0 0 17.197 17.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16876",
    "data-name": "Rectangle 16876",
    width: 17.197,
    height: 17.194,
    fill: "#ee7d11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893",
    transform: "translate(-82 -725.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11862",
    "data-name": "Group 11862",
    transform: "translate(82 725.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11861",
    "data-name": "Group 11861",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37776",
    "data-name": "Path 37776",
    d: "M14.948,2.757c0-.706,0-1.33,0-1.954a.749.749,0,0,1,.325-.676A.705.705,0,0,1,16.35.534a1.468,1.468,0,0,1,.037.361q0,1.824,0,3.648c0,.66-.256.911-.922.911-1.254,0-2.507,0-3.761,0a.714.714,0,0,1-.695-1.037.729.729,0,0,1,.72-.392c.664,0,1.329,0,1.993,0H14.1c-.116-.144-.177-.231-.25-.309a7.162,7.162,0,1,0,1.919,5.07c0-.056,0-.112.005-.168a.718.718,0,0,1,.731-.729.707.707,0,0,1,.7.758,8.344,8.344,0,0,1-.663,3.276A8.6,8.6,0,1,1,9.632.065a8.5,8.5,0,0,1,5.094,2.489c.051.051.107.1.222.2",
    transform: "translate(-0.001 0)",
    fill: "#ee7d11"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37777",
    "data-name": "Path 37777",
    d: "M12062.284,825.4v4.938h4.267",
    transform: "translate(-11972 -95)",
    fill: "none",
    stroke: "#ee7d11",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActivityIcon);
export default __webpack_public_path__ + "static/media/recentActivityIcon.a2eaabf5793cbe053f7769a6714b0173.svg";
export { ForwardRef as ReactComponent };